/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * What kind of thing an ENGAGEMENT section is pointing at. Decides which collection the engagementId resolves against and which widget renders it.
 * @export
 */
export const DropEngagementType = {
    GAMIFICATION: 'GAMIFICATION',
    COMPETITION: 'COMPETITION',
    CHALLENGE: 'CHALLENGE',
    QUEST: 'QUEST',
    ACTIVATION: 'ACTIVATION'
} as const;
export type DropEngagementType = typeof DropEngagementType[keyof typeof DropEngagementType];


export function instanceOfDropEngagementType(value: any): boolean {
    for (const key in DropEngagementType) {
        if (Object.prototype.hasOwnProperty.call(DropEngagementType, key)) {
            if (DropEngagementType[key as keyof typeof DropEngagementType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DropEngagementTypeFromJSON(json: any): DropEngagementType {
    return DropEngagementTypeFromJSONTyped(json, false);
}

export function DropEngagementTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropEngagementType {
    return json as DropEngagementType;
}

export function DropEngagementTypeToJSON(value?: DropEngagementType | null): any {
    return value as any;
}

export function DropEngagementTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): DropEngagementType {
    return value as DropEngagementType;
}

